import type { AlchemyType } from '@/domain/genetics/types';
import type { BiomeId } from './types';
import { BIOMES } from './biomes';

/**
 * exposureMultiplier(biome, types): média dos multiplicadores de decay
 * dos tipos elementais da criatura no bioma corrente.
 *
 * Para 0 tipos retorna 1 (neutro).
 */
export function exposureMultiplier(
  biome: BiomeId,
  types: ReadonlyArray<AlchemyType>,
): number {
  if (types.length === 0) return 1;
  const def = BIOMES[biome];
  let sum = 0;
  for (const t of types) sum += def.exposure[t];
  return sum / types.length;
}
